/**
 * Whether the « Tâches » page is mounted, for the sidebar badge: while it is,
 * the badge takes its counts from the page's list (`useTaskList.ts`) and
 * makes no request of its own.
 *
 * Module state, like `sharedLoad.ts`: the badge (rendered by the app's
 * layout) and the page (rendered by its route) have no common provider.
 */

import { useEffect, useSyncExternalStore } from 'react';

let mounted = 0;
const listeners = new Set<() => void>();

function notify(): void {
  for (const listener of [...listeners]) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function isShown(): boolean {
  return mounted > 0;
}

/** Called by the page: counts it as mounted for its lifetime. */
export function useTasksPagePresence(): void {
  useEffect(() => {
    mounted += 1;
    notify();
    return () => {
      mounted -= 1;
      notify();
    };
  }, []);
}

/** Whether the page is mounted, kept up to date. */
export function useTasksPageShown(): boolean {
  return useSyncExternalStore(subscribe, isShown);
}
